module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-picker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "prefix-box mdl-card mdl-shadow--2dp",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    }),
    attrs: {
      "ef": "box"
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search-panel"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Country search")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text countries"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      staticClass: "country",
      on: {
        "click": function($event) {
          _vm.countrySelected(country)
        }
      }
    }, [_c('span', {
      staticClass: "countryFlag flag-icon",
      class: 'flag-icon-' + (country.code.toLowerCase())
    }), _vm._v(" "), _c('span', {
      staticClass: "countryName"
    }, [_vm._v(_vm._s(country.name))])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3714dfb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/CountryPicker.vue
// module id = 416
// module chunks = 1